export const heightOptions = [
  { label: 'Below 48"', type: "below", value: 48 },
  { label: 'Over 60"', type: "above", value: 60 },
  { label: 'Over 72"', type: "above", value: 72 },
  { label: 'Over 80"', type: "above", value: 80 },
]; 